/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {useAppDispatch, useAppSelector} from "../store";
import {Button, Drawer, Form, Input, Menu, Modal, Select, Space} from "antd";
import {useEffect, useState} from "react";
import {closeDrawer, openDrawer} from "../reducers/drawers-reducer";
import {triggerReload} from "../reducers/reloadsignal-reducer";
import {patch, post, del, get} from "../core/request";
import {IconSet} from "../components/icons";
import {Dropdown} from "antd";
import {CustomButton} from "../components/buttons";

import {Person, User} from "../core/datamodel";
import {useHistory} from "react-router-dom";
import Password from "antd/es/input/Password";

interface DrawerProps {
    size?: 'default' | 'large'
}


export function PasswordDrawer(props: DrawerProps) {
    const stack = useAppSelector(state => state.drawer.stack)
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();

    const onFormFinish = () => {
        let values = form.getFieldsValue()

        let req = post(
            "auth/password",
            {
                'old': values.old,
                'new': values.new,
            }
        ).then(() => {
                dispatch(closeDrawer("password"))
            },
            (e) => {
                console.error(e);
            })
    }

    const onDrawerClose = () => dispatch(closeDrawer("password"))

    const form_layout = {
        labelCol: {span: 6},
        wrapperCol: {span: 16},
    };

    const form_element = (
        <Form
            form={form}
            onFinish={onFormFinish}
            {...form_layout}
        >
            <Form.Item
                label="aktuelles Passwort"
                name="old"
                required
                rules={[{required: true, message: "Bitte aktuelles Passwort eingeben!"}]}
            >
                <Password name='old' placeholder="aktuelles Passwort"/>
            </Form.Item>

            <Form.Item
                label="neues Passwort"
                name="new"
                required
                rules={[{required: true, message: "Bitte neues Passwort eingeben!"}]}
            >
                <Password name='new' placeholder="neues Passwort"/>
            </Form.Item>

            <Form.Item
                label="neues Passwort"
                name="new2"
                dependencies={['new']}
                required
                rules={[
                    {required: true, message: "Bitte neues Passwort wiederholen!"},
                    ({getFieldValue}) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('new') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('Passwörter stimmen nicht überein!'));
                        },
                    }),
                ]}
            >
                <Password name='new2' placeholder="neues Passwort"/>
            </Form.Item>

            {/* Buttons */}
            <Form.Item
                label=" "
                colon={false}
            >
                <Form.Item
                    style={{display: 'inline-block'}}
                >
                    <Button type="primary" htmlType="submit">
                        <IconSet type='save'/>&nbsp;Speichern
                    </Button>
                </Form.Item>
                <Form.Item
                    style={{display: 'inline-block', margin: '0 24px'}}
                >
                    <Button onClick={onDrawerClose}>
                        <IconSet type='cancel'/>&nbsp;Änderungen verwerfen
                    </Button>
                </Form.Item>
            </Form.Item>
        </Form>
    )

    return (
        <Drawer
            open={stack.length > 0  && stack[stack.length - 1] === "password"}
            size={props.size}
            onClose={onDrawerClose}
            forceRender={true}
            zIndex={stack[stack.length - 1] === "password" ? 1000 : 900}
            title={
                <Space direction="horizontal" style={{width: '100%', justifyContent: 'center'}}>
                    <h1 style={{marginBottom: 0}}>Passwort ändern</h1>
                </Space>
            }
        >
            {form_element}
        </Drawer>
    )
}

PasswordDrawer.defaultProps = {
    size: 'large'
}